import IBSheetLoader from '@ibsheet/loader';

const license = process.env.REACT_APP_IB_SHEET_LICENSE;

const ibSheetLib = {
  name: 'ibsheet',
  baseUrl: '/ibsheet',
  locales: ['en', 'ko'],
  plugins: ['excel', 'common', 'dialog'],
  license,
};

// 로더 ibSheet
IBSheetLoader.config({
  registry: [ibSheetLib],
});

// 로더 이벤트
IBSheetLoader.once('loaded', (evt) => {
  const target = evt.target;
  if (target.alias === ibSheetLib.name) {
    IBSheetLoader.getIBSheetStatic();
  }
});
